import * as React from "react";
import { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { UnmountClosed } from "react-collapse";
import { ActionType } from "../../../../../react-core/Flux/ActionType";

import { SelectEditor } from "../../../../../react-core/Html/SelectEditor";
import { ToggleButtonTwoOptions } from "../../../../../react-core/Html/ToggleButtonTwoOptions";
import { DividendReinvestment } from "../../../../../Wrap/Constants/Enums/Domain/DividendReinvestment";
import { AssetClassType } from "../../../../../Wrap/Constants/Enums/Domain/Instrument/AssetClassType";
import { ProductSort } from "../../../../../Wrap/Constants/Enums/Domain/ProductSort";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { SortDirection } from "../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { FundProductsQuery } from "../../../../../Wrap/Models/Domains/Investment/FundProductsQuery";
import { ResearchISTDispatcher } from "../../../../Dashboard/Components/ToolsAndLiterature/Store/Variable";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { FundType } from "../../Resource/Content";
import { AllocationTableItem } from "../../Store/SelectedInvesmentStoreStatic";
import { FundCodesSearch } from "./FundCodesSearch";
import { FundSearchResults } from "./FundSearchResult";
import { ImageOptionDropdown } from "../../../../../react-core/Html/ImageOptionDropdown";

interface IFundsSearchProps {
    hiercharyId: string;
    type: SubAccountType;
    tableData: AllocationTableItem[];
    index: number;
    researchIst: boolean;
    accountServiceProposition: ServiceProposition;
    canBeBought: boolean;
    canBeSold: boolean;
    CanBeTransferred?: boolean;
}
const InsuredFunds = 3;
const SearchTypes = {
    [DividendReinvestment.Accumulation]: "Accumulation",
    [DividendReinvestment.Income]: "Income",
    [InsuredFunds]: "Insured Funds",
};

export const FundsSearch = (props: IFundsSearchProps, ref: any) => {
    const [showResults, setShowResults] = useState(false);
    const [sectorOptions, setSectorOptions] = useState([]);
    const [sdrLabelsOptions, setSdrLabelOptions] = useState([]);
    const [fundManagerOptions, setFundManagerOptions] = useState([]);
    const [assetTier1Opitons, setAssetTier1Options] = useState([]);
    const [assetTier2Opitons, setAssetTier2Options] = useState([]);
    const [sector, setSector] = useState(null);
    const [sdrLabel, setSdrLabel] = useState(null);
    const [tier1, setTier1] = useState(null);
    const [tier2, setTier2] = useState(null);
    const [fundType, setFundType] = useState(null);
    const [isInsuredFund, setInsuredFund] = useState(false);
    const [fundManager, setFundManager] = useState(null);
    const [data, setData] = useState(null);
    const [isSearching, setIsSearching] = useState(null);
    const canPlaceInsuredFund = [
        SubAccountType.OnshoreBond,
        SubAccountType.OffshoreBond,
        SubAccountType.Npr,
        SubAccountType.Sipp,
    ];
    useImperativeHandle(ref, () => ({
        close: () => {
            setShowResults(false);
        },
    }));

    const serachFund = (pageIndex) => {
        const query: FundProductsQuery = {
            FundManagerName: fundManager,
            DividendReinvestment: fundType,
            Sectors: sector ? [sector] : null,
            SdrLabel: sdrLabel === "All" ? null : sdrLabel === "Sustainability Label" ? "All" : sdrLabel || null,
            CurrentPage: pageIndex,
            IsInsuredFund: false,
        };
        query["AssetClass"] = tier1;
        query["AssetClassT2"] = tier2;
        if (props.canBeBought) {
            query["CanBeBought"] = true;
        }
        if (props.canBeSold) {
            query["CanBeSold"] = true;
        }
        if (isInsuredFund) {
            query["ServiceProposition"] = ServiceProposition.Wrap;
        } else {
            query["ProductWrapperTypes"] = [props.type];
            query["ServiceProposition"] = props.accountServiceProposition;
        }

        query["Sorting"] = [{ Field: ProductSort.ProductCode, Direction: SortDirection.Ascending }];
        query["IsInsuredFund"] = isInsuredFund;
        if (props.researchIst) {
            ResearchISTDispatcher.dispatch({
                actionType: ActionType.Update,
                payload: (curPage: number) => {
                    const _query = JSON.parse(JSON.stringify(query));
                    _query.CurrentPage = curPage;
                    getData(_query);
                },
            });
        }
        setIsSearching(true);
        getData(query);
    };

    const getData = (query) => {
        InvestmentSelectionAction.searchFundProducts(query, props.hiercharyId, (data) => {
            setIsSearching(false);
            if (props.researchIst) {
                ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: data });
            } else {
                setData(data);
                showTableResults();
            }
        });
    };

    const getSectorOptions = () => {
        InvestmentSelectionAction.getSectors((data) => setSectorOptions(data));
    };

    const getSdrLabelOptions = () => {
        InvestmentSelectionAction.getSdrUrls((data) => {
            const sustainTypeOptions = data.map((x) => ({
                imgUrl: x.SDRUrl,
                value: x.SDRLabel,
            }));
            sustainTypeOptions.push({ imgUrl: "All label", value: "Sustainability Label" });
            setSdrLabelOptions(sustainTypeOptions);
        });
    };

    const getFundManagerOptions = () => {
        InvestmentSelectionAction.getFundManager(props.hiercharyId, (data) => setFundManagerOptions(data));
    };

    const getAssetClass = (type: AssetClassType) => {
        InvestmentSelectionAction.getAssetClasses(props.hiercharyId, type, (data) => {
            type == AssetClassType.Tier1 ? setAssetTier1Options(data) : setAssetTier2Options(data);
        });
    };

    useEffect(() => {
        getSectorOptions();
        getSdrLabelOptions();
        getFundManagerOptions();
        getAssetClass(AssetClassType.Tier1);
        getAssetClass(AssetClassType.Tier2);
    }, []);

    const showTableResults = () => {
        setShowResults(true);
    };

    return (
        <>
            <div className="ist-advanced-panel">
                <FundCodesSearch
                    hiercharyId={props.hiercharyId}
                    type={props.type}
                    index={props.index}
                    accountServiceProposition={props.accountServiceProposition}
                    canBeBought={props.canBeBought}
                    canBeSold={props.canBeSold}
                    CanBeTransferred={props.CanBeTransferred}
                />
                <hr />
                <h3>Search by fund details</h3>
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-4">
                        <SelectEditor
                            label="Fund manager"
                            placeholder="Please select"
                            options={fundManagerOptions}
                            getText={(o) => o.Name}
                            onChange={(v) => {
                                setFundManager(v?.Name);
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4">
                        <SelectEditor
                            label="Asset class T1"
                            placeholder="Please select"
                            options={assetTier1Opitons}
                            getText={(o) => o.Label}
                            onChange={(v) => {
                                setTier1(v?.Label);
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4">
                        <SelectEditor
                            label="Asset class T2"
                            placeholder="Please select"
                            options={assetTier2Opitons}
                            getText={(o) => o.Label}
                            onChange={(v) => {
                                setTier2(v?.Label);
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-sm-6 col-md-4">
                        <SelectEditor
                            label="Fund type"
                            placeholder="Please select"
                            options={Object.keys(SearchTypes).map((v) => Number(v))}
                            getText={(o) => SearchTypes[o]}
                            onChange={(v) => {
                                if (v == InsuredFunds) {
                                    setInsuredFund(true);
                                    setFundType(DividendReinvestment.NotSpecified);
                                } else {
                                    setInsuredFund(false);
                                    setFundType(v);
                                }
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4">
                        <SelectEditor
                            label="Sector"
                            placeholder="Please select"
                            options={sectorOptions}
                            getText={(o) => o.Name}
                            onChange={(v) => {
                                setSector(v?.Name);
                            }}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4">
                        <div className="form-group">
                            <label className="control-label">Sustainability type</label>
                            <ImageOptionDropdown
                                cssWrapper="is-fluid"
                                label="Please select"
                                options={sdrLabelsOptions}
                                onChange={(v) => {
                                    setSdrLabel(v);
                                }}
                            />
                        </div>
                    </div>
                    {canPlaceInsuredFund.includes(props.type) && (
                        <div className="col-12 col-sm-6 col-md-4">
                            <ToggleButtonTwoOptions
                                optionOne="Off"
                                optionTwo="On"
                                value={isInsuredFund}
                                onChange={(v) => {
                                    setInsuredFund(v);
                                }}
                                label="Is insured fund"
                            />
                        </div>
                    )}
                </div>
                <div className="text-right mb-10">
                    <button
                        onClick={() => serachFund(1)}
                        type="button"
                        className={`btn secondary ${isSearching ? "is-busy" : ""}`}
                    >
                        Search
                    </button>
                </div>
            </div>

            <UnmountClosed isOpened={showResults}>
                {!props.researchIst && data && (
                    <FundSearchResults
                        data={data}
                        allocationTable={props.tableData}
                        onPageChange={(i) => serachFund(i)}
                        index={props.index}
                        researchIst={props.researchIst}
                    />
                )}
            </UnmountClosed>
        </>
    );
};

export default forwardRef(FundsSearch);
